export const getUniqueByKey = <T>(arr: T[], key: string): T[] => {
    const seen = new Set<string>();
    return arr.filter((item) => {
        if (!(key in item)) {
            return false;
        }
        const val = item[key];
        if (val === undefined || val === null) {
            return false;
        }
        if (seen.has(val)) {
            return false;
        }
        seen.add(val);
        return true;
    });
};
